<template>
  <div class="md-radio" :class="[themeClass, classes]">
    <div class="md-radio-container" @click.stop="toggleCheck">
      <input type="radio" :name="name" :id="id" :disabled="disabled || null" :value="modelValue">
    </div>

    <label :for="id || name" class="md-radio-label" v-if="$slots.default" @click.prevent="toggleCheck">
      <slot></slot>
    </label>
  </div>
</template>

<style lang="scss" src="./mdRadio.theme"></style>
<style lang="scss" src="./mdRadio.scss"></style>

<script>
  import theme from '../../core/theme/mixins';

  export default {
    name: 'md-radio',
    props: {
      name: String,
      id: String,
      modelValue: [String, Boolean, Number],
      mdValue: {
        type: [String, Boolean, Number],
        required: true
      },
      disabled: Boolean
    },
    mixins: [theme],
    computed: {
      classes() {
        return {
          'md-checked': typeof this.modelValue !== 'undefined' && this.modelValue !== null && this.mdValue.toString() === this.modelValue.toString(),
          'md-disabled': this.disabled
        };
      }
    },
    methods: {
      toggleCheck($event) {
        if (!this.disabled) {
          this.$emit('change', this.mdValue, $event);
          this.$emit('update:modelValue', this.mdValue, $event);
        }
      }
    }
  };
</script>
